import React, { Component, useEffect, useState } from 'react';
import Header from '../Headers/Header';
import Loader from '../../loader';
import Axios from 'axios';
import configurations from '../../../configurations';

const QuickQuote = () => {
    const [isLogged, setLogged] = useState(false);
    const [loaderShow, setLoaderShow] = useState(true);

    useEffect(() => {
        const isLogged = localStorage.getItem('isLogged');
        setLogged(isLogged === 'true');

        // Check if user is logged in, redirect to login if not
        if (isLogged !== 'true') {
            window.location.href = '/login';
            return;
        }

        let retryCount = 0;
        const maxRetries = 50; // Maximum 5 seconds (50 * 100ms)

        const loadPlugin = () => {
            console.log('Checking plugin... pluginReady:', window.pluginReady, 'function exists:', !!window?.loadCommonPluginScreen, 'retry:', retryCount);

            if (window?.loadCommonPluginScreen) {
                setLoaderShow(false);
                let urlValues = window.location.hash ? window.location.hash.split('=') : [];
                if (urlValues && urlValues.length > 0) {
                    Axios.get(configurations.baseUrl + '/encrypt/decryptData?state=' + urlValues[1])
                        .then(response => {
                            if (response.data.response) {
                                let pluginObserver;
                                const mountPluginIntoContainer = () => {
                                    const container = document.getElementById('quick-quote-plugin-container');
                                    if (!container) return;
                                    const candidates = [
                                        document.getElementById('common-plugin-root'),
                                        document.getElementById('plugin-root'),
                                        document.querySelector('[data-common-plugin-root]'),
                                        document.querySelector('.common-plugin-root'),
                                        document.querySelector('.quickquote-page'),
                                        document.querySelector('[data-quickquote-root]')
                                    ].filter(Boolean);
                                    const node = candidates[0];
                                    if (node && !container.contains(node)) {
                                        container.innerHTML = '';
                                        container.appendChild(node);
                                        if (pluginObserver) pluginObserver.disconnect();
                                    }
                                };
                                // In your Agent Portal's useEffect that loads the plugin

                                // Define the handler that receives the user data from modal
                                const handlePluginClose = function (payload) {
                                    try {
                                        console.log('Plugin closed with payload:', payload);
                                        if (payload && payload.event === 'goToDashboard') {
                                            // Navigate back to dashboard
                                            window.location.href = '/';
                                        } else if (payload && payload.event === 'launchEnrollment') {
                                            // The payload now includes newUser object from the Add User modal
                                            const enrollmentObj = payload.newUser || payload.userData || JSON.parse(sessionStorage.getItem('STATE_PARAM') || '{}');

                                            const obj = {
                                                clientId: enrollmentObj.clientId || enrollmentObj.clientName,
                                                associationId: enrollmentObj.associationId,
                                                brokerId: enrollmentObj.brokerId,
                                                empid: enrollmentObj.empid || null,
                                                isAgent: enrollmentObj.isAgent,
                                                user_subId: enrollmentObj.user_subId,
                                                index: enrollmentObj.index,
                                                memberId: enrollmentObj.memberId,
                                                subID: enrollmentObj.subID,
                                                reEnrolledByAgent: enrollmentObj.reEnrolledByAgent,
                                                agentEmail: enrollmentObj.agentEmail,
                                                zipCode: payload.zipCode,
                                                selectedData: payload.selectedData,
                                            };

                                            Axios.post(configurations.baseUrl + '/encrypt/encryptData', obj)
                                                .then(res => {
                                                    if (res.data && res.data.response) {
                                                        window.location.href = '/Enrollment?state=' + res.data.response;
                                                    }
                                                })
                                                .catch(err => {
                                                    console.error('encrypt/encryptData failed', err);
                                                });
                                        }
                                    } catch (e) {
                                        console.error('Plugin close handler error', e);
                                    }
                                };

                                pluginObserver = new MutationObserver(() => {
                                    mountPluginIntoContainer();
                                });
                                pluginObserver.observe(document.body, { childList: true, subtree: true });

                                window.loadCommonPluginScreen(response.data.response.brokerId, {
                                    client: "AC",
                                    type: "QUICK_QUOTE",
                                    theme: "light",
                                    userRole: "AGENCY",
                                    agencyId: response.data.response.clientId,
                                    source: "Agent",
                                    initiatedUser: response.data.response.agentEmail,
                                    userData: response.data.response,
                                    onClose: handlePluginClose,  // <-- Pass the callback
                                    containerId: "quick-quote-plugin-container",
                                    targetId: "quick-quote-plugin-container"
                                });

                                setTimeout(() => {
                                    mountPluginIntoContainer();
                                    if (pluginObserver) pluginObserver.disconnect();
                                }, 3000);

                                // Also register as fallback
                                window.onClose = handlePluginClose;
                            }
                        })
                }
            } else {
                // Plugin not loaded yet - retry with backoff
                retryCount++;
                if (retryCount < maxRetries) {
                    console.log('Plugin not ready yet, retrying... (' + retryCount + '/' + maxRetries + ')');
                    setTimeout(loadPlugin, 100); // Retry in 100ms
                } else {
                    console.error('Plugin failed to load after', retryCount, 'attempts. pluginReady is:', window.pluginReady);
                    setLoaderShow(false);
                    alert('Failed to load Quick Quote plugin. Please refresh the page.');
                }
            }
        };

        loadPlugin();
    }, []);

    const goToDashboard = () => {
        window.location.href = '/';
    };

    return (
        <div style={{ display: isLogged === 'true' ? 'none' : 'block', minHeight: '100vh' }}>
            {loaderShow ? <Loader></Loader> : ''}
            <div style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                <Header />
            </div>
            <div style={{ backgroundColor: '#23436c', color: '#fff', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontSize: '16px', fontWeight: 600 }}>QUICK QUOTE</div>
                <button
                    onClick={goToDashboard}
                    style={{
                        backgroundColor: '#23436c',
                        color: '#fff',
                        border: '1px solid #23436c',
                        cursor: 'pointer',
                        fontWeight: 600
                    }}
                >
                    GO TO DASHBOARD
                </button>
            </div>
            <div style={{ padding: '16px', boxSizing: 'border-box', overflowY: 'auto', maxHeight: 'calc(100vh - 130px)' }}>
                <div
                    id="quick-quote-plugin-container"
                    style={{ minHeight: '100vh', width: '100%' }}
                />
            </div>
        </div>
    )
}

export default QuickQuote;
